import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";

/**
 * Replaces the composer in a closed conversation (plan §3.6): the banner
 * «انتهت هذه المحادثة ولا يمكن متابعتها…» and «بدء محادثة جديدة». The button
 * is the view's primary control (autoFocus, D36) and is described by the
 * banner, so a screen reader hears why the composer is gone.
 *
 * @param {{ onStartNew: () => void }} props
 */
export default function ReadOnlyFooter({ onStartNew }) {
  const { t } = useTranslation("aiSupport");
  const bannerId = useId();

  return (
    <Box sx={{ flexShrink: 0, borderTop: 1, borderColor: "divider", p: 2 }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: 1.5 }}>
        <LockOutlined
          fontSize="small"
          color="action"
          aria-hidden="true"
          sx={{ mt: 0.25 }}
        />
        <Typography id={bannerId} variant="body2" color="text.secondary">
          {t("conversation.readOnlyBanner")}
        </Typography>
      </Box>
      <Button
        variant="contained"
        fullWidth
        autoFocus
        aria-describedby={bannerId}
        onClick={() => onStartNew()}
        sx={{ textTransform: "none" }}
      >
        {t("panel.newConversation")}
      </Button>
    </Box>
  );
}
